export const TRANSLATION_SCOPE = 'settingsClientCustomModule';
export const TRANSLATION_GRID_SCOPE = [TRANSLATION_SCOPE, 'grid'];
export const TRANSLATION_CRUD_SCOPE = [TRANSLATION_SCOPE, 'crud'];
export const TRANSLATION_LAYOUT_SCOPE = [TRANSLATION_SCOPE, 'layout'];
export const TRANSLATION_DEFAULT_SCOPE = [TRANSLATION_SCOPE, 'default'];
export const TRANSLATION_MASTER_DATA_SCOPE = [TRANSLATION_SCOPE, 'masterData'];
export const TRANSLATION_GRID_RENDERER_SCOPE = [TRANSLATION_SCOPE, 'gridRenderer'];

